import React from 'react';
import styled from 'styled-components';
import { HudIcon } from '../Icons/HudIcons';

const SpinnerIcon = styled(HudIcon)<{ color: string }>`
  color: ${({ color }) => color};
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;

interface SpinnerProps {
  size?: string;
  color?: string;
}

export default function Spinner({ size = '18px', color = 'turquoise' }: SpinnerProps) {
  return <SpinnerIcon icon="other.spinner" size={size} color={color} />;
}
